<template>
  <v-footer dark padless>
    <v-card flat tile class="secondary white--text text-center">
      <!-- <v-card-text>
        <v-btn
          v-for="(icon, i) in icons"
          :key="i"
          class="mx-4 white--text"
          :href="icon.link"
          target="_blank"
          icon
        >
          <v-icon size="24px">{{ icon.text }}</v-icon>
        </v-btn> 
      </v-card-text>-->

      <v-card-text class="white--text pt-0">
        <!-- 浙江星寰科技有限公司 -->
         <a class="footerColor" href="https://beian.miit.gov.cn/" target="_blank"
        >浙ICP备2021037954号-1</a
      >
      </v-card-text>
      
      <v-divider></v-divider>

      <!-- <v-card-text class="white--text">
        {{ new Date().getFullYear() }} — <strong>Stoic Solutions</strong>
        {{ new Date().getFullYear() }}-{{ new Date().getMonth()+1 }}-{{ new Date().getDate() }}
         — <strong>Stoic Solutions</strong>
      </v-card-text> -->
      <!-- <v-card-text>
        
      </v-card-text> -->
    </v-card>
  </v-footer>
</template>

<style scoped>
.v-card {
  width: 100%;
}
.footerColor {
  color: white; /* 将链接字体颜色设置为黑色 */
  text-decoration: none; /* 去除下划线 */
}
</style>

<script>
export default {
  // data: () => ({
  //   icons: [
  //     {
  //       text: "mdi-facebook",
  //       link: "",
  //     },
  //     {
  //       text: "mdi-twitter",
  //       link: "",
  //     },
  //     {
  //       text: "mdi-linkedin",
  //       link: "",
  //     },
  //     {
  //       text: "mdi-instagram",
  //       link: "https://instagram.com/joabson_arley/",
  //     },
  //   ],
  // }),
};
</script>
